import { jsx as _jsx } from "react/jsx-runtime";
import { Badge } from '#pplx/frontend/aether/components/Badge/index.js';
import { FormattedMessage } from 'react-intl';
export function ComputerCommandMenuNewBadge() {
    return (_jsx("span", { "aria-hidden": "true", className: "shrink-0 inline-flex", children: _jsx(Badge, { variant: "info", children: _jsx(FormattedMessage, { defaultMessage: "New", description: "Badge label for a newly added Computer command menu item", id: "4e43181dae" }) }) }));
}
//# sourceMappingURL=ComputerCommandMenuNewBadge.js.map